import { Filter } from '@vrplatform/components';
import type { SelectItem } from '@vrplatform/components';
import { Group } from '@mantine/core';
import { useMemo } from 'react';
import {
  AUDIT_EFFECT_ENTITY_TYPES,
  AUDIT_EFFECT_STATUSES,
  AUDIT_EFFECT_TYPES,
  useAuditEffectsTableFilter,
} from './useAuditEffectsTableFilter';
import { sortBy } from '@vrplatform/utils';

export const AuditEffectsTableFilter = () => {
  'use memo';

  return (
    <Group gap="xs">
      {/* <Search /> */}
      <Status />
      <EffectType />
      <EntityType />
    </Group>
  );
};

const _Search = () => {
  'use memo';

  const { filter, setFilter } = useAuditEffectsTableFilter();

  return (
    <Filter.Search
      value={filter.search || ''}
      setValue={(v) => setFilter({ search: v || null })}
    />
  );
};

const Status = () => {
  'use memo';

  const { filter, setFilter } = useAuditEffectsTableFilter();

  const options = useMemo<SelectItem[]>(
    () =>
      sortBy(
        Object.entries(AUDIT_EFFECT_STATUSES).map(([value, label]) => ({
          value,
          label,
        })),
        'label'
      ),
    []
  );

  const value = options.find((i) => i.value === filter.status) || null;

  return (
    <Filter.Select
      value={value}
      label="Status"
      setValue={(v) =>
        setFilter({
          status: (v?.value as keyof typeof AUDIT_EFFECT_STATUSES) ?? null,
        })
      }
      type="single"
      data={{
        options,
      }}
      hideIcon
      popoverWidth={300}
    />
  );
};

const EffectType = () => {
  'use memo';

  const { filter, setFilter } = useAuditEffectsTableFilter();

  const options = useMemo<SelectItem[]>(
    () =>
      sortBy(
        Object.entries(AUDIT_EFFECT_TYPES).map(([value, label]) => ({
          value,
          label,
        })),
        'label'
      ),
    []
  );

  const value = options.find((i) => i.value === filter.effectType) || null;

  return (
    <Filter.Select
      value={value}
      label="Effect Type"
      setValue={(v) =>
        setFilter({
          effectType: (v?.value as keyof typeof AUDIT_EFFECT_TYPES) ?? null,
        })
      }
      type="single"
      data={{
        options,
      }}
      hideIcon
      popoverWidth={300}
    />
  );
};

const EntityType = () => {
  'use memo';

  const { filter, setFilter } = useAuditEffectsTableFilter();

  const options = useMemo<SelectItem[]>(
    () =>
      sortBy(
        Object.entries(AUDIT_EFFECT_ENTITY_TYPES).map(([value, label]) => ({
          value,
          label,
        })),
        'label'
      ),
    []
  );

  const value = options.find((i) => i.value === filter.entityType) || null;

  return (
    <Filter.Select
      value={value}
      label="Entity Type"
      setValue={(v) =>
        setFilter({
          entityType:
            (v?.value as keyof typeof AUDIT_EFFECT_ENTITY_TYPES) ?? null,
        })
      }
      type="single"
      data={{
        options,
      }}
      hideIcon
      popoverWidth={300}
    />
  );
};
